import { createVNode, render, isVNode } from "vue";
import popUp from "./src/pop-up.vue";
import type { PopUpProps } from "./src/pop-up";
import type { App, Component } from "vue";

const convertJsonKey = (obj: Record<string, any>) => {
  const result = {};
  for (let key in obj) {
    const keyVal = obj[key];
    key = `on${key.replace(key[0], key[0].toUpperCase())}`;
    result[key] = keyVal;
  }
  return result;
};
popUp.install = (app: App) => {
  app.component(popUp.name, popUp);
  app.config.globalProperties.$modal = ({
    options,
    component,
    props: childProps,
    on = {},
  }: {
    options: Partial<PopUpProps>;
    component: Component;
    props: Record<string, any>;
    on: Record<string, any>;
  }) => {
    const { close, confirm, ...child } = on;
    const onChild = convertJsonKey(child);
    const componentVnode = createVNode(component, {
      ...childProps,
      ...onChild,
    });
    const vnode = createVNode(
      popUp,
      {
        onConfirm: (value: any) => {
          if (confirm) {
            confirm(value, _closeModal);
          }
        },
        "onUpdate:modelValue": (value: any) => {
          if (!value) _closeModal();
        },
        onClose: (value: any) => {
          if (close) {
            close(value);
          }
        },
      },
      {
        default: () => componentVnode,
        ...(isVNode(options.titleExtra) && {
          "title-extra": () => options.titleExtra,
        }),
      }
    );
    vnode.appContext = app._context;
    const container = document.createElement("div");
    render(vnode, container);
    const instance = vnode.component;
    document.body.appendChild(container);
    // 获取实例的 props ，进行传递 props
    const { props } = instance;
    Object.assign(props, options, { modelValue: true });
    // 关闭弹窗方法
    const _closeModal = () => {
      props.modelValue = false;
      container.parentNode?.removeChild(container);
    };
  };
};
export const xPopUp = popUp;
export default xPopUp;
export * from "./src/pop-up";
